import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrSunSetupListingOrderDetail = ({ title, subtitle, subtitleColor, maxWidth }) => {
  return (
    <SrBox
      maxWidth={maxWidth}
    >
      <SrBox>
        <SrText
          font='greycliff'
          fontSize='14px'
          weight='800'
        >
          {title}
        </SrText>
      </SrBox>
      <SrBox>
        <SrText
          font='greycliff'
          fontSize='15px'
          weight='600'
          color={subtitleColor || 'grey'}
        >
          {subtitle}
        </SrText>
      </SrBox>
    </SrBox>
  );
};

SrSunSetupListingOrderDetail.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  subtitleColor: PropTypes.string,
  maxWidth: PropTypes.string,
};

export default SrSunSetupListingOrderDetail;
